export const PASSWORD_STRENGTH_PASSWORD_CHANGED =
  'PASSWORD_STRENGTH_PASSWORD_CHANGED';
export const PASSWORD_STRENGTH_PASSWORD_CONFIRMATION_CHANGED =
  'PASSWORD_STRENGTH_PASSWORD_CONFIRMATION_CHANGED';
